<template>
  <div class="block_wrap">
    <div class="row client">
      <div class="col-md-12">
        <label> {{ translate('user.client') }} </label>
        <tree-select
            :options="clients_list"
            v-model="upd_user.client_id"
            :placeholder="translate('user.client')"
            :searchable="true"
            :multiple="false"
            :clearable="false"
            :disabled="check_client_id"
        />
      </div>
    </div>

    <div class="row">
      <div class="col-md-4">
        <fg-input
          v-model="upd_user.name"
          type="text"
          :label="translate('user.name')"
          :placeholder="translate('user.name')"
          :disabled="!check_create_new_user"
        />
      </div>

      <div class="col-md-4 main_name">
        <fg-input
          v-model="upd_user.username"
          type="text"
          :label="translate('user.login')"
          :placeholder="translate('user.login')"
          :disabled="!check_create_new_user"
        />
      </div>

      <div class="col-md-4 filter checkbox" v-show="check_create_new_user">
        <div class="info">
          {{ active_user ? translate('user.active') : translate('user.blocked')}}
        </div>
        <label class="switch" @click.prevent="active_user = !active_user">
          <input type="checkbox" v-model="active_user" >
          <span class="slider round"></span>
        </label>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <fg-input
          v-model="upd_user.email"
          type="email"
          label="Email"
          placeholder="Email"
          :disabled="!check_create_new_user"
        />
      </div>

      <div class="col-md-6">
        <fg-input
          autocomplete="sdfgsdfgsfhsdfgsdfh"
          v-model="upd_user.phone"
          :type="'tel'"
          :label="translate('user.phone')"
          @keydown="restrict_chars($event)"
          :placeholder="translate('user.phone')"
          :name="'asdgasdfasgd'"
          :disabled="!check_create_new_user"
        />
      </div>
    </div>

    <div class="update_password row">
      <fg-input
          name="npu"
          class="col-md-4"
          autocomplete="off"
          v-model="upd_user.password"
          type="text"
          :label="translate('user.password.one')"
          :placeholder="translate('user.password.one')"
          :disabled="!check_create_new_user"
      />
      <fg-input
          name="npu"
          class="col-md-4"
          autocomplete="off"
          v-model="upd_user.conf_password"
          type="text"
          :label="translate('user.password.confirm')"
          :placeholder="translate('user.password.confirm')"
          :disabled="!check_create_new_user"
      />
      <div class="col-md-4">
        <button
          :disabled="!check_create_new_user"
          class="btn btn-info btn-fill cstm-lg-mt-26 cstm-sm-mb-26"
          @click.prevent="generate"
        >
          {{ translate('user.password.generate') }}
        </button>
      </div>
    </div>

    <div class="line" v-if="upd_user.last_try_ts" >
        <div class="input_wrap">
          <p>
            {{ translate('user.created') }}:
            {{ get_date(upd_user.ts_create) }}
            <span v-if="upd_user.create_by?.username" >
              {{ translate('user.by') }} {{ upd_user.create_by?.username }}
            </span>
          </p>
          <p :style="'color: ' + last_try_date(upd_user.last_try_ts)?.color">
            {{ translate('user.last_try_ts') }}:
            {{ last_try_date(upd_user.last_try_ts).date }}
          </p>
        </div>
    </div>

    <div class="line" v-if="changes && check_create_new_user">
      <div class="button_wrap">
        <button
          class="btn btn-success btn-fill btn-wd"
          @click.prevent="update_profile"
        >
          save
        </button>
      </div>
    </div>

  </div>
</template>
<script>

export default {
  name: 'UserMainInfo',
  props: ['main_info'],

  data () {
    return {
      upd_user: {},
      active_user: true
    }
  },
  computed:{
    check_create_new_user() {
      if (this.main_info.id) {
        return this.$store.getters.getPermissions.editUser === true
      } else {
        return this.$store.getters.getPermissions.createUser === true
      }
    },
    changes(){
      let main_info = Object.assign({}, this.main_info)
      let upd_user = Object.assign({}, this.upd_user)

      delete(main_info.ts_update)
      delete(upd_user.ts_update)

      return JSON.stringify(main_info) !== JSON.stringify(upd_user)
    },
    clients_list(){
      let list = []
      for (let client of this.$store.getters.getClientsList) {
        list.push({label: client.name, id: client.id})
      }
      return list
    },
    check_client_id(){
      return this.main_info.client_id !== null
    }
  },
  created() {
    this.upd_user = {...this.main_info}

    if (this.upd_user.client_id === ''){
      this.upd_user.client_id = null
    }

    this.active_user = this.upd_user.active === 1
  },
  watch:{
    active_user(){
      this.upd_user.active = this.active_user ? 1 : 0
    },
    main_info(){
      this.upd_user = {...this.main_info}
    }
  },
  methods: {
    last_try_date(last_try_ts){
      if (!last_try_ts) return

      let now = Math.round(+new Date()/1000)
      let diff = now - last_try_ts
      if (diff < 60*60*24*30){ //если разница меньше 30 дней
        return {color: "#66615b", date: this.get_date(last_try_ts)}
      }else if (diff > 60*60*24*30*3){ //если разница больше 90 дней
        return {color: "#b84141", date: this.get_date(last_try_ts)}
      }else{ //если от 30 до 90 дней
        return {color: "#F3BB45", date: this.get_date(last_try_ts)}
      }
    },
    randomPassword (length) {
      let chars = 'abcdefghjkmnpqrstuvwxyzABCDEFGHJKLMNP23456789'
      let pass = ''
      let i
      for (let x = 0; x < length; x++) {
        i = Math.floor(Math.random() * chars.length)
        pass += chars.charAt(i)
      }
      return pass
    },

    generate () {
      this.$set(this.upd_user, 'password', this.randomPassword(8))
      this.upd_user.conf_password = this.upd_user.password
    },

    update_profile () {

      if (this.upd_user.name === '' || this.upd_user.name === undefined) {
        this.global_notify('danger', this.translate('user.field.username'))
        return
      }

      if (this.upd_user.username === '' || this.upd_user.username === undefined) {
        this.global_notify('danger', this.translate('user.field.login'))
        return
      }

      if (this.upd_user.password !== this.upd_user.conf_password) {
        this.global_notify('danger', this.translate('user.password.not_match'))
        return
      }

      this.upd_user.client_id = this.upd_user.client_id === '' ? null : this.upd_user.client_id

      this.disabled_btn = true

      if (this.upd_user.password === '' || this.upd_user.password === undefined) {
        this.global_notify('danger', this.translate('user.password.need'))
        return
      }

      this.$http.v1.createUser(this.upd_user, (response) => {
        this.global_notify('info', this.translate('user.user_created'))
        this.$router.push(`/user/${response.data.id}`)
        this.$emit('close')
      })
    },
  }
}

</script>

<style lang='scss' scoped>
  .block_wrap{
    text-align: left;
    .client{
      margin-bottom: 10px;
    }
    .update_password{
      .btn{
        height: 40px;
        width: 100%;
      }
    }
  }

</style>
